import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";
import {
  convertTo12HourFormat,
} from "../../../../../helpers/helpers";
import { Modal } from "react-materialize";
import ReverseBidHistory from "../table/ReverseBidHistory";

function ServiceLiveSingleLotInfo({ liveOfferData, bidderDetails }) {
  const isDastop = useMediaQuery({ query: "(max-width: 1600px)" });
  const isLaptop = useMediaQuery({ query: "(max-width: 1200px)" });
  const [isOpenModel, setIsOpenModel] = useState(false);

  const closeModal = () => {
    setIsOpenModel(false);
  };

  return (
    <div
      className={`live-room-font ${
        isLaptop ? "14px" : isDastop ? "font-16px" : "font-18px"
      }`}
      style={{
        display: "grid",
        gridTemplateColumns: isLaptop
          ? "repeat(2,1fr)"
          : "400px 0.8fr 0.6fr 0.7fr",
        padding: "1rem",
        gap: isLaptop && "0.6rem",
        fontWeight: 600,
      }}
    >
      <span className={`flex column ${isLaptop ? "gap-5px" : "gap-1"}`}>
        <p>
          EMD Amount :{" "}
          <span className="cercle-purple-text">{liveOfferData?.EMDAmount}</span>
        </p>
        <p>
          Service Title :{" "}
          <span className="cercle-purple-text">
            {liveOfferData?.serviceDetails?.title}
          </span>
        </p>
      </span>
      <span className="valign-wrapper gap-1">
        <p className="black" style={{ width: "0.5px", height: "100%" }}></p>
        <span className={`flex column ${isLaptop ? "gap-5px" : "gap-1"}`}>
          <p>
            Category :{" "}
            <span className="cercle-purple-text">
              {liveOfferData?.serviceDetails?.category}
            </span>
          </p>
          <p>
            Starting Price :{" "}
            <span
              className={`${
                isLaptop ? "cercle-purple-text" : "white-text"
              } font-20px`}
              style={{
                padding: isLaptop ? "" : isDastop ? "5px 25px" : "7px 30px",
                borderRadius: "8px",
                backgroundImage:
                  !isLaptop && "linear-gradient(to right, #4C2171 , #6F2DA8)",
                fontWeight: "bolder",
                letterSpacing: 2,
              }}
            >
              {liveOfferData?.startingPrice}
            </span>
          </p>
        </span>
      </span>
      <span
        className="valign-wrapper gap-1"
        style={{ marginTop: isLaptop && "-10px" }}
      >
        {!isLaptop && (
          <p className="black" style={{ width: "0.5px", height: "100%" }}></p>
        )}
        <span className={`flex column ${isLaptop ? "gap-5px" : "gap-1"}`}>
          <p>
            Starting time:{" "}
            <span className="cercle-purple-text">
              {" "}
              {convertTo12HourFormat(
                liveOfferData?.offerSchedule?.startTimeAndDate
              )}
            </span>
          </p>
          <p>
            Closing time:{" "}
            <span className="cercle-purple-text">
              {" "}
              {convertTo12HourFormat(
                liveOfferData?.offerSchedule?.endTimeAndDate
              )}
            </span>
          </p>
        </span>
      </span>
      <span className="valign-wrapper gap-1">
        <p className="black" style={{ width: "0.5px", height: "100%" }}></p>
        <span className={`flex column ${isLaptop ? "gap-5px" : "gap-1"}`}>
          <p>
            No. of Quantity:{" "}
            <span className="cercle-purple-text">
              {liveOfferData?.serviceDetails?.quantity}
            </span>
          </p>
          <p>
            Bid History :
            <button
              className={`button-style pointer font-14px cercle-purple white-text ml-1`}
              style={{
                padding: "4px 25px",
              }}
              onClick={() => setIsOpenModel(true)}
            >
              View
            </button>
          </p>
        </span>
      </span>
      <Modal
        actions={[]}
        bottomSheet={false}
        fixedFooter={false}
        style={styles.modal}
        className="modelAccount"
        id="modalView-details"
        open={isOpenModel}
        options={{ onCloseEnd: () => closeModal() }}
      >
        <h5 className="margin-0px flex justify-center">Bid History</h5>
        <div
          className="valign-wrapper space-between mt-1 mr-1 font-18px"
          style={{ marginBottom: "0.5rem" }}
        >
          <span>
            Lot {liveOfferData?.offerNumber} :{" "}
            {liveOfferData?.serviceDetails?.title} 
          </span>
          <span className="font-16px red-text">Last 10 Lowest bids </span>
        </div>
        <ReverseBidHistory bidderDetails={bidderDetails} />
      </Modal>
    </div>
  );
}

const styles = {
  modal: {
    maxHeight: "1000px",
  },
};

export default ServiceLiveSingleLotInfo;
